import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Reply, Star, Paperclip } from "lucide-react";

function Typer({ text, active }) {
  const [shown, setShown] = useState("");
  useEffect(() => {
    if (!active) { setShown(""); return; }
    setShown("");
    let i = 0;
    const id = setInterval(() => {
      i += 2;
      setShown(text.slice(0, i));
      if (i >= text.length) clearInterval(id);
    }, 16);
    return () => clearInterval(id);
  }, [text, active]);
  return (
    <span className={active && shown.length < text.length ? "typer" : ""}>
      {shown}
    </span>
  );
}

export function DraftView({ item, onBack }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid={`draft-view-${item.id}`}
    >
      <button
        onClick={onBack}
        className="btn-link font-sans-tight text-[13px] text-[#0B3D5C] mb-3"
        data-testid="draft-back"
      >
        ← Back to brief
      </button>
      <div className="flex items-center gap-2 mb-3">
        <span
          className="text-[10px] font-sans-tight font-bold uppercase tracking-wider px-2 py-1 text-white"
          style={{ background: item.pillColor }}
        >
          {item.pill}
        </span>
        <Star size={14} className="text-[#E07B3A]" />
        <span className="font-mono-spec text-[11px] text-[#4A4A4A] ml-auto">
          Draft · ready to send
        </span>
      </div>
      <h4 className="font-sans-tight font-bold text-[1.25rem] tracking-tight">
        {item.title}
      </h4>
      <p className="font-mono-spec text-[12px] text-[#4A4A4A] mt-1">
        {item.meta}
      </p>

      <div className="mt-5 border border-[#E5E0D8] rounded-sm">
        <div className="px-4 py-3 border-b border-[#E5E0D8] flex items-center gap-2 bg-[#FBF9F4]">
          <Reply size={14} className="text-[#0B3D5C]" />
          <span className="font-mono-spec text-[11px] text-[#4A4A4A]">
            From your inbox · drafted by Atlas
          </span>
        </div>
        <div className="p-5 font-serif-body text-[15.5px] leading-relaxed text-[#1A1A1A] min-h-[180px]">
          <Typer text={item.draft} active />
        </div>
        <div className="px-5 py-3 border-t border-[#E5E0D8] flex items-center gap-3 bg-[#FBF9F4]">
          <button className="btn btn-primary py-2 px-4 text-[13px]" data-testid="draft-send-button">
            <Reply size={14} /> Send
          </button>
          <button className="btn btn-ghost py-2 px-4 text-[13px]" data-testid="draft-edit-button">
            <Paperclip size={14} /> Edit first
          </button>
          <span className="ml-auto font-mono-spec text-[11px] text-[#4A4A4A]">
            We never send. You do.
          </span>
        </div>
      </div>
    </motion.div>
  );
}
